export default __webpack_public_path__ + "static/media/back-btn-light.d4c36f2a.svg";